import { Dayjs } from "dayjs"
import { IMandrillEmail } from "./mandrillEmail.types"

export class MandrillEmail implements IMandrillEmail {
  emailSentDate: Dayjs
  opens: number
  sender: string
  status: string | null
  subject: string
  clicks: number
  bounceDetail: string | null

  constructor(
    emailSentDate: Dayjs,
    opens: number,
    sender: string,
    status: string | null,
    subject: string,
    clicks: number,
    bounceDetail: string | null,
  ) {
    this.emailSentDate = emailSentDate
    this.opens = opens
    this.sender = sender
    this.status = status
    this.subject = subject
    this.clicks = clicks
    this.bounceDetail = bounceDetail
  }
}
